import { detectQuestionDirection } from "@/app/activity/components/questionSettings/QuestionSettings";
import React, { ForwardRefRenderFunction, forwardRef, useId } from "react";

export type InputProps = {
  error?: boolean;
  errorMessage?: string;
  title?: string;
  placeholder: string;
  styleClass?: string;
  handleInput?: (
    e: React.ChangeEvent<HTMLInputElement>,
    index?: number
  ) => void;
  handleTextArea?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  value?: string;
  textareaRow?: number;
  disable?: boolean;
  isMandatory?: boolean;
  children?: React.ReactNode;
  id?: string;
  type?: string;
  includeIcon?: boolean;
  autoComplete?: string;
  maxLength?: number;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  inputMode?: "numeric";
  pattern?: string;
  onFocus?: () => void;
  onBlur?: () => void;
  trailingIcon?: JSX.Element;
  tabIndex?: number;
  photoPadding?: string;
};

const Input: ForwardRefRenderFunction<HTMLInputElement, InputProps> =
  function Input(
    {
      error,
      errorMessage,
      title,
      placeholder,
      styleClass,
      handleInput,
      handleTextArea,
      value,
      textareaRow,
      disable,
      isMandatory,
      children,
      id,
      type,
      includeIcon,
      autoComplete,
      maxLength,
      onKeyDown,
      inputMode,
      pattern,
      onFocus,
      onBlur,
      trailingIcon,
      tabIndex,
      photoPadding,
    },
    ref
  ) {
    const id_input = useId();
    return (
      <div
        className={`w-full relative flex ${
          styleClass && styleClass.includes("h-full") ? "h-full" : ""
        }`}
      >
        <div className="w-full h-full flex flex-col justify-start items-start gap-1">
          <div className="flex flex-col items-start rounded w-full h-full">
            <div className=" flex flex-col w-full gap-1.5  h-full">
              {title && (
                <div className="text-text-caption text-right text-xs ">
                  <span className="caption ">{title}</span>{" "}
                  {isMandatory && <span className="text-error-text">*</span>}
                </div>
              )}
              <div
                className={
                  styleClass
                    ? "relative w-full " + styleClass
                    : "relative w-full  "
                }
              >
                {textareaRow ? (
                  <textarea
                    className={` resize-none commoninput p-3 w-full ${styleClass} `}
                    rows={textareaRow}
                    placeholder={placeholder}
                    value={value}
                    onChange={handleTextArea}
                    disabled={disable}
                    id={id ? id : id_input}
                    autoComplete={autoComplete}
                    maxLength={maxLength}
                    ref={ref as unknown as React.Ref<HTMLTextAreaElement>}
                    inputMode={inputMode}
                    onFocus={onFocus}
                    onBlur={onBlur}
                    dir={detectQuestionDirection(value)}
                  />
                ) : (
                  <input
                    tabIndex={tabIndex ?? 0}
                    className={
                      styleClass && includeIcon && photoPadding
                        ? " p-3 commoninput min-h-[52px] rtl-placeHolder placeholder:pe-10 text-wrap " +
                          styleClass +
                          photoPadding
                        : styleClass && includeIcon
                          ? " ps-10 commoninput min-h-[52px] rtl-placeHolder placeholder:pe-10 text-wrap " +
                            styleClass
                          : styleClass
                            ? " p-3 commoninput  min-h-[52px] text-wrap" +
                              styleClass
                            : includeIcon
                              ? " p-3 commoninput min-h-[52px] rtl-placeHolder  placeholder:pe-10 text-wrap "
                              : " commoninput p-3 min-h-[52px] "
                    }
                    onChange={handleInput}
                    placeholder={placeholder}
                    value={value}
                    disabled={disable}
                    id={id ? id : id_input}
                    type={type}
                    autoComplete={autoComplete}
                    maxLength={maxLength}
                    onKeyDown={onKeyDown}
                    ref={ref as React.Ref<HTMLInputElement>}
                    inputMode={inputMode}
                    pattern={pattern}
                    onFocus={onFocus}
                    onBlur={onBlur}
                    dir={detectQuestionDirection(value)}
                  />
                )}
                {children}
                {trailingIcon && (
                  <div className={`icontrailing  absolute left-2`}>
                    {trailingIcon}
                  </div>
                )}
              </div>
            </div>
            {error && (
              <div className="text-error-text text-right text-[10px] font-medium leading-4 h-2.5">
                {error ? errorMessage : ""}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

export default forwardRef(Input);
